import React from "react";
import mapData from "./BeverageChartDataMapper";
import PieChart from "./PieChartContainer";

export default ({dt, data: {beverageStatData}}) => <PieChart mappedData={mapData(beverageStatData, dt)}/>;